import { estimate } from './estimate';
import { faq } from './faq';
import { remzone } from './remzone';
import { reviews } from './reviews';

export function pdr() {
  remzone();
  reviews();
  faq();
  estimate();
}
